export const UserTypeConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    ADMIN_REGISTER_REQUEST: 'ADMIN_REGISTER_REQUEST',
    ADMIN_REGISTER_SUCCESS: 'ADMIN_REGISTER_SUCCESS',
    ADMIN_REGISTER_FAILURE: 'ADMIN_REGISTER_FAILURE',
    ADMIN_GETALL_REQUEST: 'ADMIN_GETALL_REQUEST',
    ADMIN_GETALL_SUCCESS: 'ADMIN_GETALL_SUCCESS',
    ADMIN_GETALL_FAILURE: 'ADMIN_GETALL_FAILURE',
    ADMIN_UPDATE_REQUEST: 'ADMIN_UPDATE_REQUEST',

    GET_USER_BY_ID_REQUEST : 'GET_USER_BY_ID_REQUEST',
    GET_USER_BY_ID_SUCCESS : 'GET_USER_BY_ID_SUCCESS',
    GET_USER_BY_ID_FAILIURE : 'GET_USER_BY_ID_FAILIURE',


    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',
    VERIFY_USER:'VERIFY_USER', 
    CHANGE_PASSWORD:'CHANGE_PASSWORD',
    ADMIN_GETALL_HCP_REQUEST:'ADMIN_GETALL_HCP_REQUEST',
    UPDATE_PASSWORD:'UPDATE_PASSWORD',
    VALIDATE_EMAIL:'VALIDATE_EMAIL',
    VALIDATE_EMAIL_SUCCESS:'VALIDATE_EMAIL_SUCCESS',
    UPDATE_SECRET_QUESTION_REQUEST:'UPDATE_SECRET_QUESTION_REQUEST',
    UPDATE_SECRET_QUESTION_SUCCESS:'UPDATE_SECRET_QUESTION_SUCCESS',
    GET_SECRET_QUESTION_REQUEST:'GET_SECRET_QUESTION_REQUEST',
    GET_SECRET_QUESTION_SUCCESS:'GET_SECRET_QUESTION_SUCCESS',
    VALIDATE_SECRET_QUESTION_REQUEST:'VALIDATE_SECRET_QUESTION_REQUEST',
    VALIDATE_SECRET_QUESTION_SUCCESS:'VALIDATE_SECRET_QUESTION_SUCCESS',
    GET_SECRET_QUESTION_FAILIURE:'GET_SECRET_QUESTION_FAILIURE',
    SEND_OTP_REQUEST : 'SEND_OTP_REQUEST',
    SEND_OTP_SUCCESS : 'SEND_OTP_SUCCESS',
    SEND_OTP_FAILIURE : 'SEND_OTP_FAILIURE',
    VALIDATE_OTP_REQUEST : 'VALIDATE_OTP_REQUEST',
    VALIDATE_OTP_SUCCESS : 'VALIDATE_OTP_SUCCESS',
    VALIDATE_OTP_FAILIURE : 'VALIDATE_OTP_FAILIURE',
    CLEAR_ADMIN : 'CLEAR_ADMIN',
};